{
  "admin_user": {
    "title": "Admin Users",
    "subtitle": "Staff user accounts",
    "columns": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "roleType": "Role Type",
      "saleAssigned": "Sale Assigned",
      "csAssigned": "CS Assigned",
      "lastLogin": "Last Login",
      "isActive": "Active",
      "createdAt": "Created",
      "user": "User",
      "roles": "Roles",
      "status": "Status",
      "twoFactor": "2FA",
      "updated": "Updated",
      "actions": "Actions"
    },
    "actions": {
      "create": "Create User",
      "edit": "Edit",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "resetPassword": "Reset Password",
      "impersonate": "Impersonate",
      "assignSale": "Assign Sale",
      "assignCs": "Assign CS",
      "revokeCredit": "Revoke Credit",
      "editCredit": "Edit Credit Limit"
    },
    "filters": {
      "role": "Role",
      "roleType": "Role Type",
      "saleAssigned": "Sale Assigned",
      "csAssigned": "CS Assigned",
      "status": "Status",
      "search": "Search by name or email",
      "allRoles": "All roles",
      "allStatuses": "All statuses"
    },
    "tabs": {
      "details": "Details",
      "permissions": "Permissions",
      "credit": "Credit",
      "auditLog": "Audit Log"
    },
    "fields": {
      "fullName": "Full Name",
      "email": "Email",
      "phone": "Phone",
      "role": "Role",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "isActive": "Active"
    },
    "empty": {
      "title": "No users found",
      "body": "Adjust your filters or create a new user."
    },
    "errors": {
      "duplicateEmail": "A user with this email already exists",
      "weakPassword": "Password must be at least 12 characters with mixed case and numbers",
      "passwordMismatch": "Passwords do not match",
      "cannotImpersonate": "You do not have permission to impersonate this user",
      "cannotDeactivateSelf": "You cannot deactivate your own account"
    },
    "confirm": {
      "deactivate": "Deactivate this user? They will lose access immediately.",
      "resetPassword": "Send a password reset email to this user?",
      "impersonate": "Impersonate this user? Your actions will be logged in audit."
    },
    "page": {
      "heading": "Admin account management",
      "subtitleWithTotal": "Manage roles, suspension, 2FA reset and impersonation. {{total}} users total."
    },
    "search": {
      "placeholder": "Search email or name…"
    },
    "rowActions": {
      "grant": "Grant",
      "revoke": "Revoke",
      "suspend": "Suspend",
      "unsuspend": "Unsuspend",
      "reset2fa": "Reset 2FA",
      "selfGuard": "You cannot edit your own account"
    },
    "twoFactor": {
      "enabledTitle": "2FA enabled",
      "disabledTitle": "2FA not enabled",
      "badgeOn": "2FA",
      "badgeOff": "Off"
    },
    "avatar": {
      "viewAlt": "View {{name}}'s avatar"
    },
    "roleOptions": {
      "superadmin": "Superadmin",
      "admin": "Admin",
      "support": "Support",
      "saler": "Saler",
      "manager": "Manager",
      "accountant": "Accountant",
      "affiliate": "Affiliate"
    },
    "accountTypes": {
      "merchant": "Merchant",
      "vendor": "Vendor",
      "affiliate": "Affiliate"
    },
    "statusLabels": {
      "active": "Active",
      "pending_otp": "Unverified",
      "pending_approval": "Pending approval",
      "pending_survey": "Pending survey",
      "suspended": "Suspended",
      "banned": "Banned",
      "deleted": "Deleted",
      "inactive": "Inactive"
    },
    "drawer": {
      "aria": "Account details for {{name}}",
      "close": "Close",
      "closeAria": "Close drawer",
      "viewAvatarAria": "View {{name}}'s avatar",
      "fields": {
        "status": "Status",
        "twoFactor": "2FA",
        "roles": "Roles",
        "id": "ID",
        "createdAt": "Created at",
        "updatedAt": "Updated at",
        "lastLoginAt": "Last login",
        "avatarUrl": "Avatar URL"
      },
      "neverLoggedIn": "Never",
      "avatarFallback": "— (initials fallback)",
      "viewFull": "View full details →",
      "fullIncludes": "Includes permissions, activity, sessions"
    },
    "roleDialog": {
      "titleGrant": "Grant role — {{name}}",
      "titleRevoke": "Revoke role — {{name}}",
      "roleLabel": "Role",
      "rolePlaceholder": "Select role…",
      "noRevocableRoles": "This user has no revocable roles.",
      "reasonLabel": "Reason (audit, 10-500 chars)",
      "cancel": "Cancel",
      "grant": "Grant",
      "revoke": "Revoke"
    },
    "confirmAction": {
      "suspendTitle": "Suspend {{name}}?",
      "unsuspendTitle": "Unsuspend {{name}}?",
      "reset2faTitle": "Reset 2FA for {{name}}?",
      "suspendDesc": "Cascades to team members. All sessions revoked.",
      "unsuspendDesc": "Restores user to Active state.",
      "reset2faDesc": "Clears TOTP enrollment + recovery codes. Sensitive Tier A.",
      "reasonPlaceholder": "Reason (10-500 chars, audit trail)",
      "confirmLabel": "Confirm",
      "reasonRequiredTitle": "Reason required",
      "reasonRequiredDesc": "Minimum 10 characters for audit trail."
    },
    "toast": {
      "loadFailTitle": "Failed to load users",
      "networkErrorTitle": "Network error",
      "unknown": "Unknown",
      "actionFailTitle": "Action failed",
      "unknownError": "Unknown error",
      "suspendedTitle": "User suspended",
      "unsuspendedTitle": "User unsuspended",
      "reset2faTitle": "User 2FA reset",
      "roleUpdateFailTitle": "Role update failed",
      "roleGrantedTitle": "Role granted",
      "roleRevokedTitle": "Role revoked"
    },
    "createDialog": {
      "title": "Create admin account",
      "fields": {
        "email": "Email",
        "displayName": "Display name",
        "role": "Role"
      },
      "roleOptions": {
        "admin": "Admin",
        "support": "Support Admin",
        "saler": "Saler",
        "manager": "Manager",
        "accountant": "Accountant",
        "affiliate": "Affiliate"
      },
      "checkbox": {
        "title": "Send invite email",
        "onLabel": "Send the invite email right after creating the account",
        "offLabel": "Do not send the invite email (admin will send it later)",
        "help": "Uncheck to create the account first and send the invite email later from the detail page."
      },
      "submitInvite": "Create & send invite",
      "submitInviteLoading": "Creating & sending invite…",
      "submitNoInvite": "Create (no invite)",
      "submitNoInviteLoading": "Creating…",
      "toast": {
        "successInvite": "Account created and invite email sent (1 sent successfully)",
        "successNoInvite": "Account created (invite email not sent)",
        "failTitle": "Could not create account",
        "failDesc": "The network did not respond."
      }
    }
  },
  "detail": {
    "back": "Back to Users",
    "backToList": "Back to list",
    "missingId": "Missing account ID in the URL.",
    "loadError": "Could not load account details: {{message}}",
    "unknownError": "Unknown error.",
    "additionalRoles": "+ {{count}} additional role(s)",
    "selfBanner": "This is your own account — you cannot lock yourself out or sign out all your sessions here.",
    "tabs": {
      "profile": "Profile",
      "permissions": "Roles & Permissions",
      "activity": "Activity",
      "sessions": "Sessions"
    },
    "statusLabels": {
      "active": "Active",
      "inactive": "Suspended",
      "locked": "Locked"
    },
    "activity": {
      "totalPrefix": "Total",
      "totalSuffix": "activities.",
      "categoryOptions": {
        "all": "All activity",
        "login": "Login",
        "role_change": "Role change",
        "security": "Security",
        "page_visit": "Recent pages"
      },
      "categoryBadge": {
        "login": "Login",
        "role_change": "Role",
        "security": "Security",
        "page_visit": "Visit"
      },
      "loadError": "Could not load activity:",
      "empty": "No activity in this category yet.",
      "columns": {
        "type": "Type",
        "event": "Event",
        "detail": "Details",
        "ipDevice": "IP / Device",
        "time": "Time"
      },
      "pageLabel": "Page:",
      "loadingMore": "Loading...",
      "loadMore_one": "Load {{count}} more row",
      "loadMore_other": "Load {{count}} more rows",
      "events": {
        "ADMIN_ROLE_CREATE": "Admin role created",
        "ADMIN_ROLE_DELETE": "Admin role deleted",
        "ADMIN_ROLE_UPDATE": "Admin role updated",
        "ADMIN_USER_2FA_SETUP": "2FA enrolled for user",
        "ADMIN_USER_CREATE": "Admin account created",
        "ADMIN_USER_ROLE_GRANT_INITIAL": "Initial role granted",
        "AUTH_2FA_CHALLENGE": "2FA challenge issued",
        "AUTH_2FA_DISABLED": "2FA disabled",
        "AUTH_2FA_SETUP": "2FA setup",
        "AUTH_2FA_VERIFY": "2FA verified",
        "AUTH_BILLING_UPDATE": "Billing info updated",
        "AUTH_IMPERSONATE_START": "Impersonation started",
        "AUTH_LOGIN": "Signed in",
        "AUTH_LOGIN_FAILED": "Sign-in failed",
        "AUTH_LOGIN_LOCKED": "Account locked after failed sign-ins",
        "AUTH_LOGOUT": "Signed out",
        "AUTH_PASSWORD_CHANGE": "Password changed",
        "AUTH_PROFILE_UPDATE": "Profile updated",
        "AUTH_REFRESH": "Session refreshed",
        "AUTH_REFRESH_FAILED": "Session refresh failed",
        "AUTH_REGISTER": "Account registered",
        "AUTH_SESSION_REVOKED": "Session revoked",
        "AUTH_SURVEY_SUBMIT": "Survey submitted",
        "AUTH_USER_2FA_RESET": "2FA reset for user",
        "AUTH_USER_ROLE_GRANT": "Role granted",
        "AUTH_USER_ROLE_REVOKE": "Role revoked",
        "AUTH_USER_SUSPEND": "User suspended",
        "AUTH_USER_UNSUSPEND": "User reinstated",
        "AUTH_USER_UPDATE": "User updated",
        "AUTH_VENDOR_APPROVE": "Vendor approved",
        "AUTH_WS_SUBSCRIBE_DENIED": "Realtime subscription denied",
        "EMAIL_TEMPLATE_CREATE": "Email template created",
        "FRAUD_SETTINGS_UPDATED": "Fraud settings updated",
        "INVENTORY_OVERVIEW_VIEW": "Viewed inventory overview",
        "INVENTORY_REPORT_AGING_EXPORT": "Exported aging report",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Exported movement report",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Exported stock level report",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Exported turnover report",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Exported valuation report",
        "INVENTORY_STOCK_VIEW": "Viewed stock list",
        "KYC_DOCUMENT_APPROVED": "KYC document approved",
        "LEGAL_ENTITY_CREATED": "Legal entity created",
        "PRODUCT_APPROVAL_APPROVED": "Product approved",
        "SYSTEM_BACKUP_TRIGGERED": "Backup triggered",
        "VENDOR_BANK_VERIFIED": "Vendor bank account verified",
        "admin_invoice_pdf_download": "Downloaded invoice PDF",
        "admin_payment_request_create": "Payment request created",
        "admin_payment_request_pdf_download": "Downloaded payment request PDF",
        "approval_request_executed": "Approval request executed",
        "approval_request_rejected": "Approval request rejected",
        "approval_request_voted": "Voted on approval request",
        "billing_invoice_manually_generated": "Invoice generated manually",
        "billing_mode_switched": "Billing mode switched",
        "billing_refund_task_completed": "Refund task completed",
        "billing_address_create": "Billing address created",
        "blueprint_create": "Blueprint created",
        "blueprint_update": "Blueprint updated",
        "invoice_pdf_download": "Downloaded invoice PDF",
        "merchant_invoice_created": "Merchant invoice created",
        "payout_approved": "Payout approved",
        "payout_mark_transferred": "Payout marked transferred",
        "payout_rejected": "Payout rejected",
        "products_special_create": "Special product created",
        "products_special_update_assignments": "Special product assignments updated",
        "queue_pause": "Queue paused",
        "settings_update": "Settings updated",
        "support_ticket_created": "Support ticket created",
        "support_ticket_escalated": "Support ticket escalated",
        "support_ticket_updated": "Support ticket updated",
        "support_ticket_message_created": "Support ticket reply added",
        "vendor_capacity_current_active_changed": "Vendor active capacity changed"
      },
      "targetLabel": "Target",
      "noDetail": "No further detail"
    },
    "permissions": {
      "description": "Effective permissions — merged from the base role and additional grants. Grouped by domain.",
      "emptyNoPerms": "This account has no permissions granted yet."
    },
    "profile": {
      "fields": {
        "name": "Display name",
        "email": "Email",
        "primaryRole": "Primary role",
        "status": "Status"
      },
      "statusOptions": {
        "active": "Active",
        "inactive": "Temporarily locked",
        "locked": "Permanently locked"
      },
      "selfLockHint": "You cannot lock your own account.",
      "roleManagedHint": "Managed via Grant/Revoke role on the users list.",
      "statusManagedHint": "Managed via Suspend/Unsuspend on the users list.",
      "save": "Save changes",
      "saving": "Saving...",
      "toast": {
        "updateFailTitle": "Update failed",
        "updateFailDesc": "Could not save changes.",
        "savedTitle": "Saved",
        "savedDesc": "Account profile updated."
      }
    },
    "sessions": {
      "lastLogin": "Last login",
      "lastIp": "Last IP",
      "activeHeading": "Active sessions",
      "activeAt": "Last active",
      "loading": "Loading sessions…",
      "loadError": "Could not load sessions.",
      "empty": "No active sessions.",
      "unknownDevice": "Unknown device",
      "revokeAllHeading": "Sign out all sessions",
      "revokeAllDesc": "This will revoke every active login session for the account. The user will be forced to sign in again from all devices.",
      "selfNote": "You are viewing your own account — you cannot sign out your own sessions here. Use the Sign out button in the navigation bar if needed.",
      "revokeAllBtn": "Sign out all sessions",
      "processing": "Processing...",
      "confirmTitle": "Confirm signing out all sessions",
      "confirmDescLine1": "Are you sure you want to revoke all active sessions for this account? The user will have to sign in again on every device.",
      "confirmDescLine2": "The action will be recorded in the audit log.",
      "confirmLabel": "Sign out all",
      "toast": {
        "revokedTitle": "Sessions signed out",
        "revokedDesc_one": "Signed out {{count}} active session.",
        "revokedDesc_other": "Signed out {{count}} active sessions.",
        "failTitle": "Failed to sign out sessions",
        "failDesc": "Could not sign out sessions."
      }
    }
  },
  "impersonate": {
    "button": "Impersonate",
    "prompt": "Impersonate {{name}}\n\nProvide a reason (audit trail, 10-500 chars):",
    "reasonTooShortTitle": "Reason too short",
    "reasonTooShortDesc": "Minimum 10 characters required for audit.",
    "failedTitle": "Impersonate failed",
    "invalidResponseTitle": "Invalid impersonate response",
    "invalidResponseDesc": "Server did not return redirectUrl.",
    "networkErrorTitle": "Network error",
    "unknown": "Unknown"
  },
  "merchantCredit": {
    "heading": "Credit history",
    "description": "All credit granted to this merchant.",
    "grantNew": "Grant new credit",
    "statusLabel": "Status:",
    "clear": "Clear",
    "status": {
      "active": "Active",
      "overdue": "Overdue",
      "expired": "Expired",
      "revoked": "Revoked"
    },
    "columns": {
      "status": "Status",
      "limit": "Limit",
      "remaining": "Remaining",
      "period": "Period (days)",
      "start": "Start",
      "end": "End",
      "created": "Created",
      "createdBy": "Created by",
      "actions": "Actions"
    },
    "loading": "Loading credit history…",
    "empty": {
      "title": "This merchant has no credit yet",
      "bodyWithName": "{{name}} has no credit history yet.",
      "body": "No credit history yet.",
      "cta": "Grant first credit"
    },
    "filteredEmpty": "No credit matches the selected filter.",
    "rowActions": {
      "edit": "Edit",
      "revoke": "Revoke",
      "viewDetails": "View Details",
      "hide": "Hide"
    },
    "tx": {
      "loading": "Loading transactions…",
      "error": "Failed to load transactions: {{message}}",
      "unknown": "Unknown",
      "empty": "No transactions (CREDIT_USAGE / CREDIT_PAYMENT) on this credit yet.",
      "columns": {
        "type": "Type",
        "amount": "Amount",
        "when": "When",
        "txGroup": "tx_group"
      }
    }
  },
  "saleCs": {
    "title": "Assign Sale / CS",
    "titleWithName": "Assign Sale / CS — {{name}}",
    "saleLabel": "Sale staff (Sale staff)",
    "csLabel": "CS staff (Customer Support)",
    "saleAria": "Sale assignee",
    "csAria": "CS assignee",
    "none": "(none)",
    "loadingList": "Loading list…",
    "clearAria": "Clear {{label}}",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "usersError": "Could not load the admin staff list (check connection or permissions)",
    "toast": {
      "success": "Sale/CS assigned",
      "failTitle": "Failed to save Sale/CS",
      "failFallback": "Save failed"
    }
  },
  "revokeCredit": {
    "title": "Revoke credit",
    "debtWarning": "Already used is still owed — the merchant must repay {{amount}}.",
    "remainingNote": "Remaining balance after revoke: {{amount}}. This action cannot be undone.",
    "reasonLabel": "Revoke reason (audit, {{min}}-{{max}} chars)",
    "needMoreChars": "Need {{count}} more character(s)",
    "enoughChars": "Long enough",
    "cancel": "Cancel",
    "submit": "Revoke",
    "submitting": "Revoking…",
    "reasonRequired": "Reason required — minimum 10 characters.",
    "failFallback": "Revoke failed",
    "toast": {
      "successTitle": "Credit revoked",
      "successDesc": "History updated."
    }
  },
  "role": {
    "title": "Roles",
    "subtitle": "Admin role definitions",
    "columns": {
      "name": "Role Name",
      "userCount": "Users",
      "permissionCount": "Permissions",
      "isSystem": "System Role",
      "updatedAt": "Updated"
    },
    "actions": {
      "create": "Create Role",
      "edit": "Edit Permissions",
      "duplicate": "Duplicate",
      "delete": "Delete"
    },
    "fields": {
      "name": "Role Name",
      "description": "Description",
      "permissions": "Permissions"
    },
    "errors": {
      "cannotDeleteSystem": "System roles cannot be deleted",
      "cannotDeleteInUse": "Cannot delete — role is assigned to {{count}} user(s)",
      "duplicateName": "A role with this name already exists"
    },
    "readOnlyBuiltIn": "System role — view only.",
    "readOnlyNoPermission": "You do not have edit access (role:manage required).",
    "editor": {
      "titleView": "View role: {{name}}",
      "titleEdit": "Edit role: {{name}}",
      "titleCreate": "Create custom role",
      "createBtn": "Create role",
      "builtInBanner": "System (built-in) role — view only, cannot be edited. To grant custom permissions, create a new role from the Admin permission pool.",
      "catalogLoadError": "Could not load the permission catalog. Reload the page to try again.",
      "loadingCatalog": "Loading permission catalog…",
      "fields": {
        "code": "Role code (slug)",
        "name": "Role name",
        "description": "Description (optional)"
      },
      "placeholders": {
        "code": "e.g. finance_ops",
        "name": "e.g. Finance Operations",
        "description": "Role purpose and team scope"
      },
      "permissionsLegend": "Permissions (Data Permissions)",
      "permissionsHelp": "The permission tree is grouped by module. Permissions with an amount threshold show a tier selector — choosing the unlimited tier automatically grants the baseline threshold too.",
      "selectedCountPrefix": "Selected:",
      "selectedCountSuffix": "permissions",
      "validation": {
        "codeMin": "Role code must be at least 2 characters",
        "codeMax": "Role code must be at most 50 characters",
        "codePattern": "Role code may only contain lowercase letters, numbers, underscores",
        "nameMin": "Role name must be at least 2 characters",
        "nameMax": "Role name must be at most 200 characters",
        "descMax": "Description must be at most 2000 characters",
        "permMin": "At least 1 permission is required for the role"
      },
      "toast": {
        "savedTitle": "Role saved",
        "createdTitle": "Role created",
        "savedDesc": "Role \"{{name}}\" has been updated.",
        "savedDescCount": "Role \"{{name}}\" updated — granted {{granted}}, revoked {{revoked}}.",
        "createdDesc": "Role \"{{name}}\" has been created.",
        "saveFail": "Failed to save role."
      }
    },
    "dataPerms": {
      "selectRole": "Select a role on the left to view its data permission configuration.",
      "loading": "Loading data permission configuration…",
      "loadError": "Could not load data permission configuration",
      "heading": "Data permissions (by column)",
      "editableHint": "Configuration applies to list / detail / export / report.",
      "noScreens": "No screen has registered a column configuration yet.",
      "selectAllAria": "Select all columns for {{name}}",
      "all": "All",
      "colsSuffix": "columns",
      "toast": {
        "savedDesc": "Data permissions for the role updated successfully.",
        "failTitle": "Save failed",
        "failDesc": "Could not save data permissions. Please try again."
      }
    },
    "matrix": {
      "selectRole": "Select a role on the left to view the permission matrix.",
      "loading": "Loading permission matrix…",
      "loadError": "Could not load permission matrix",
      "heading": "Permission matrix",
      "selectedCount": "Selected {{selected}}/{{total}} permissions.",
      "toast": {
        "savedDesc": "Permissions for the role updated successfully.",
        "failTitle": "Save failed",
        "failDesc": "Could not save permissions. Please try again."
      }
    },
    "list": {
      "heading": "Roles",
      "subtitle": "Built-in roles (Super Admin / Admin / Accountant / Support) plus custom roles created from the Admin permission pool.",
      "subtitleGate": "Manage roles and permissions for admin / super admin.",
      "noReadPermission": "You do not have permission to view the admin role list (role:read required). Contact a superadmin.",
      "createBtn": "Create custom role",
      "readOnlyBanner": "You can only view the list (read-only). Creating / editing / deleting roles requires role:manage — contact a superadmin.",
      "columns": {
        "name": "Role name",
        "description": "Description",
        "type": "Type",
        "permissionCount": "Permissions",
        "memberCount": "Members",
        "actions": "Actions"
      },
      "loading": "Loading role list…",
      "empty": "No roles yet. Contact a superadmin to seed them.",
      "typeBuiltIn": "System",
      "typeCustom": "Custom",
      "viewPerms": "View permissions",
      "edit": "Edit",
      "delete": "Delete",
      "deleteBlockedTitle": "{{count}} members still use this role — move them before deleting",
      "confirmDeleteTitle": "Delete role \"{{name}}\"?",
      "confirmDeleteDesc": "Role {{code}} will be permanently deleted. This action is recorded in the audit log and cannot be undone.",
      "confirmBlockedDesc": "{{count}} members still use this role — move them before deleting. Each admin must have at least 1 role.",
      "cannotDelete": "Cannot delete",
      "confirmDeleteLabel": "Delete role",
      "toast": {
        "deletedTitle": "Role deleted",
        "deletedDesc": "The role has been removed from the system.",
        "cannotDeleteTitle": "Cannot delete role",
        "hasMembersWithCount": "{{count}} members still use this role — move them before deleting.",
        "hasMembers": "The role still has members — move them before deleting.",
        "deleteFailTitle": "Failed to delete role",
        "deleteFailFallback": "Failed to delete role."
      }
    },
    "permEditor": {
      "title": "Edit role permissions: {{name}}",
      "defaultReason": "Update permissions for role {{role}}",
      "previewSaveError": "The role has no real id — preview mode, cannot save.",
      "crossScopeError": "Some permissions are outside the admin scope. The server rejected them — please deselect the related permissions.",
      "saveFail": "Save failed",
      "previewBannerTitle": "Preview mode.",
      "previewBannerBody": "Loading and saving permissions is not available yet. The permission group UI (Billing, Audit, …) is ready for preview.",
      "applyWarningPrefix": "Applies immediately to",
      "applyWarningSuffix": "admin users.",
      "catalogEmpty": "The system has not initialized the permission catalog. Contact a superadmin.",
      "legend": "Permissions (by module)",
      "newBadge": "New",
      "impersonateBlocked": "Impersonate-blocked",
      "reasonLabel": "Reason for change (audit log)",
      "reasonPlaceholder": "e.g. Grant billing permissions to the finance team per ticket #1234",
      "validation": {
        "minOne": "Select at least 1 permission for the role.",
        "crossScope": "Merchant-scope permissions cannot be assigned to an admin role: {{keys}}",
        "reasonMin": "Reason must be at least 10 characters (audit log requirement).",
        "reasonMax": "Reason must be at most 500 characters."
      },
      "toast": {
        "savedTitle": "Role permissions saved",
        "savedDesc": "+{{added}} permissions · -{{removed}} permissions"
      }
    }
  },
  "permission": {
    "title": "Permissions",
    "categories": {
      "finance": "Finance",
      "catalog": "Catalog",
      "orders": "Orders",
      "users": "Users & Roles",
      "support": "Support",
      "merchant": "Merchant Management",
      "vendor": "Vendor Management",
      "system": "System"
    },
    "tree": {
      "expandAll": "Expand All",
      "collapseAll": "Collapse All",
      "selectAll": "Select All",
      "clearAll": "Clear All",
      "tierUnlimited": "Unlimited",
      "tierUpTo": "≤ {{amount}} USD",
      "empty": "The permission catalog is empty. Contact a superadmin to initialize it.",
      "amountGateBadge": "Amount-gated",
      "amountGateHint": "Choose the maximum threshold for this role.",
      "thresholdAria": "Threshold for {{path}}",
      "noGrant": "Not granted"
    },
    "customBadge": "Custom",
    "domainLabels": {
      "invoice": "Invoice",
      "credit_memo": "Credit memo",
      "refund_task": "Refund task",
      "aging_report": "Aging report",
      "legal_entity": "Legal entity",
      "pricing": "Pricing",
      "products": "Products",
      "product": "Products",
      "support": "Support",
      "user": "User management",
      "admin_user": "Admin management",
      "system": "System",
      "dashboard": "Dashboard",
      "orders": "Orders",
      "vendors": "Vendors",
      "merchants": "Merchants",
      "stores": "Stores",
      "finance": "Finance",
      "impersonate": "Impersonate"
    }
  },
  "common": {
    "cancel": "Cancel",
    "save": "Save changes",
    "saving": "Saving…",
    "close": "Close",
    "saved": "Saved",
    "loading": "Loading…",
    "unknownError": "Unknown error.",
    "all": "All",
    "delete": "Delete",
    "continue": "Continue",
    "retry": "Retry",
    "back": "Back"
  },
  "adminMgmt": {
    "twoFa": {
      "title": "Enable 2FA for {{name}}",
      "wizardAria": "2FA enrollment wizard",
      "stepsAria": "2FA enrollment steps",
      "steps": {
        "setup": "Scan QR",
        "verify": "Enter TOTP code",
        "done": "Save recovery codes"
      },
      "generatingSecret": "Generating 2FA secret…",
      "qrAlt": "2FA QR code",
      "scanHint": "Scan the QR with Google Authenticator / Authy / 1Password, or enter the secret below manually.",
      "continue": "Continue",
      "setupErrorFallback": "Could not initialize 2FA.",
      "retry": "Retry",
      "totpLabel": "6-digit code from your Authenticator app",
      "back": "Back",
      "verifying": "Verifying…",
      "verify": "Verify",
      "recoveryIntro_one": "Save the {{count}} recovery code below in a safe place. If you lose access to your Authenticator app, this is the ONLY way to sign in again. Each code can be used once.",
      "recoveryIntro_other": "Save the {{count}} recovery codes below in a safe place. If you lose access to your Authenticator app, this is the ONLY way to sign in again. Each code can be used once.",
      "copy": "Copy",
      "downloadTxt": "Download .txt file",
      "ackLabel_one": "I have saved the {{count}} recovery code in a safe place.",
      "ackLabel_other": "I have saved the {{count}} recovery codes in a safe place.",
      "ackDownloaded": " (File downloaded)",
      "finish": "Finish",
      "recoveryFile": {
        "title": "Printway — 2FA Recovery Codes",
        "userPrefix": "User:",
        "generatedPrefix": "Generated:",
        "instruction": "Keep this file in a safe place. Each code can be used only once."
      },
      "toast": {
        "setupFailTitle": "Could not initialize 2FA",
        "verifyFailTitle": "Incorrect 2FA code",
        "copiedTitle_one": "Copied {{count}} recovery code",
        "copiedTitle_other": "Copied {{count}} recovery codes",
        "copyFailTitle": "The browser refused clipboard access",
        "copyFailDesc": "Please download the recovery codes file instead."
      }
    },
    "create": {
      "title": "Create admin account",
      "dialogAria": "Create new admin",
      "fields": {
        "email": "Email",
        "name": "Display name",
        "role": "Role"
      },
      "emailHint": "Use a company email (@printway.work, @printway.io, @techagents.one). An invite email with a first-login link will be sent to this address.",
      "roleHint": "Super Admin is not available here — promote via the row action with an audit reason.",
      "autoGenTitle": "Auto-generate a temporary password",
      "autoGenHelp": "The password will be sent via the invite email. The account becomes active only after completing the 3-step 2FA enrollment.",
      "roleOptions": {
        "admin": "Admin",
        "support_admin": "Support Admin",
        "accountant": "Accountant",
        "saler": "Saler",
        "manager": "Manager"
      },
      "submit": "Create & enable 2FA",
      "submitLoading": "Creating…",
      "toast": {
        "successTitle": "Admin created — invite email sent",
        "failTitle": "Could not create admin",
        "successDescription": "{{email}} ({{role}}) will set a password and enroll 2FA at first login."
      },
      "emailPlaceholder": "name@printway.work"
    }
  },
  "customRoles": {
    "title": "Custom roles",
    "subtitle": "Assign admin custom roles (extra permissions on top of the primary role).",
    "empty": "No custom roles assigned.",
    "placeholder": "Select a custom role…",
    "grantBtn": "Grant",
    "granted": "Custom role granted",
    "grantError": "Could not grant role",
    "revoked": "Custom role revoked",
    "revokeError": "Could not revoke role",
    "removeAria": "Remove role {{role}}"
  }
}
